import React from 'react';

import './style.css';

const ButtPlug = ({skintone}) => (
  <svg width="110px" className="ButtPlug" viewBox="0 0 140.39 223.64">
    <g id="Ebene_2">
      <g id="Plug">
        <path d="M57.25,67.5A41.35,41.35,0,0,0,98.43,102l6.14,36.28c-8.73,4.81-13.79,16-11.78,28,24.42,79.11,47.26,73.69,45-7.62-2-11.92-10.5-20.85-20.33-22.52l-6.15-36.28a41.35,41.35,0,1,0-54-32.27Zm71.28-12.07A30.94,30.94,0,1,1,92.86,30.09,30.93,30.93,0,0,1,128.53,55.43Z" fill="#c6bddc"/>
        <path d="M110.81,136.05c12.41-2.1,24.47,8,26.94,22.52a115.43,115.43,0,0,0-45,7.62C90.33,151.65,98.4,138.15,110.81,136.05Z" fill="#b3a7d0"/>
        <path d="M57.25,67.5A41.35,41.35,0,0,0,98.43,102l6.14,36.28c-8.73,4.81-13.79,16-11.78,28,24.42,79.11,47.26,73.69,45-7.62-2-11.92-10.5-20.85-20.33-22.52l-6.15-36.28a41.35,41.35,0,1,0-54-32.27Zm71.28-12.07A30.94,30.94,0,1,1,92.86,30.09,30.93,30.93,0,0,1,128.53,55.43Z" fill="none" stroke="#8e82a3" strokeWidth="2"/>
        <path d="M107.94,4a47,47,0,0,1,6.92,16.33C120.79,48,101,75.58,70.69,82.09S11,71.48,5.05,43.86a46.89,46.89,0,0,1-.39-17.71" fill={skintone.fill} stroke={skintone.stroke} strokeLinecap="round" strokeWidth="8"/>
      </g>
    </g>
  </svg>
);

export default ButtPlug;


// WEBPACK FOOTER //
// ./src/game/components/toys/ButtPlug/index.js